import './plugins/axios'
import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/assets/css/tailwind.css'
import '@/assets/import.js'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createHead } from "@vueuse/head"
import { vue3Debounce } from 'vue-debounce'
import { QuillEditor } from '@vueup/vue-quill'
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faStar as faEmptyStar } from '@fortawesome/free-regular-svg-icons';
import { faBars, faCodePullRequest, faPen, faList, faReplyAll, faQuestionCircle, faTimes, faEye, faStar, faBagShopping, faHomeAlt, faComment, faTruckFast, faFolder, faArrowRight, faCircleDot, faEdit, faSync, faEllipsis, faAngleRight, faFolderOpen, faPlus, faWindowMinimize, faLocationDot, faLocation, faTrash, faFaceAngry, faFaceFrown, faFaceMeh, faFaceSmile, faFaceLaughBeam, faStoreAlt, faSortAmountDown, faExclamation, faQuestion, faThumbsDown, faInfoCircle, faThumbsUp, faWeightHanging, faBoxOpen, faChevronDown, faCalendarTimes, faEnvelope, faMobile, faCalendarAlt, faSearch, faUser, faSignInAlt, faCartPlus, faChevronLeft, faPercentage, faAddressBook, faInfo} from '@fortawesome/free-solid-svg-icons';
import { faTelegram, faAtlassian, faTwitter, faFacebook, faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';


library.add(
    faList,
    faPen,
    faReplyAll,
    faQuestionCircle,
    faCodePullRequest,
    faHomeAlt,
    faComment,
    faTruckFast,
    faCircleDot,
    faArrowRight,
    faEllipsis,
    faAngleRight,
    faSync,
    faEdit,
    faFolderOpen,
    faFolder,
    faLocation,
    faTrash,
    faFaceLaughBeam,
    faFaceSmile,
    faFaceMeh,
    faFaceFrown,
    faFaceAngry,
    faWindowMinimize,
    faPlus,
    faExclamation,
    faQuestion,
    faSortAmountDown,
    faInfoCircle,
    faWeightHanging,
    faBoxOpen,
    faStoreAlt,
    faChevronDown,
    faCalendarTimes,
    faLocationDot,
    faMobile,
    faEnvelope,
    faBagShopping,
    faSearch,
    faUser,
    faCalendarAlt,
    faStar,
    faInfo,
    faAddressBook,
    faPercentage,
    faChevronLeft,
    faCartPlus,
    faEmptyStar,
    faSignInAlt,
    faBars,
    faTimes,
    faEye,
    faThumbsUp,
    faThumbsDown,
    faTelegram,
    faAtlassian,
    faTwitter,
    faFacebook,
    faWhatsapp,
    faInstagram,
);


const SweetAlert = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#ff7674',
};
const debounceConfig = {
    lock: true,
    listenTo: 'keyup',
    defaultTime: '500ms',
    fireOnEmpty: false,
    trim: false
}

const dateTimeConfig = {
    name: 'CustomDatePicker',
    props: {
        format: 'YYYY-MM-DD',
        displayFormat: 'jYYYY-jMM-jDD',
        editable: false,
        inputClass: 'form-control my-custom-class-name',
        placeholder: 'روز-ماه-سال',
        altFormat: 'YYYY-MM-DD',
        color: '#e1e1e1',
        autoSubmit: true,
    }
}

const app = createApp(App)
// app.config.errorHandler = (err, instance, info) => {
//     // report error to tracking services
// }
const head = createHead()

app.component('QuillEditor', QuillEditor)
app.component('DatePicker', Vue3PersianDatetimePicker)
app.component('font-awesome-icon', FontAwesomeIcon)

app.use(store)
    .use(router)
    .use(VueSweetalert2, SweetAlert)
    .use(Toast)
    .use(head)
    .use(Vue3PersianDatetimePicker, dateTimeConfig)
    .directive('debounce', vue3Debounce(debounceConfig))
    .mount('#app')
